<template>
  <div class="dataBox">
    <el-table
      :data="tableData"
      style="width: 100%;margin-bottom:10px;"
      border
      header-cell-class-name="cellCustomer headerCellCustomer ft14"
      cell-class-name="cellCustomer ft12"
    >
      <template slot="empty">
        <img class="data-pic" src="../../../../../assets/images/H5/null.png" alt>
        <br>暂无数据
      </template>
      <el-table-column prop="code" label="合同编号"></el-table-column>
      <el-table-column prop="name" label="合同名称"></el-table-column>
      <el-table-column label="待签署方">
        <template slot-scope="scope">{{getSignList(scope.row)}}</template>
      </el-table-column>
      <el-table-column prop="creditAssignee" label="委托方"></el-table-column>
      <el-table-column prop="updateTime" label="更新日期"></el-table-column>
      <el-table-column label="操作" width="257px">
        <template slot-scope="scope">
          <div class="handlerBoxCenter">
            <div
              class="cursorPointer revoke"
              v-if="judgeShowRevoke(scope.row)"
              @click="revoke(scope.row)"
            >
              <!-- <span class="icon"></span> -->
              <span class="iconDscp">撤销</span>
            </div>
            <div class="cursorPointer tip" @click="tipPerson(scope.row)">
              <!-- <span class="icon"></span> -->
              <span class="iconDscp">提醒</span>
            </div>
            <div class="cursorPointer " @click="toDetail(scope.row)">
              <!-- <span class="icon"></span> -->
              <span class="iconDscp">详情</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: []
    };
  },
  mounted() {},
  methods: {
    setData(data) {
      this.tableData = data;
    },
    getTaskId(data, flag, all) {
      if (data && data.length) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].actionCode === flag) {
            if (all) {
              return data[i];
            } else {
              return data[i].taskId;
            }
          }
        }
      }

      return false;
    },
    tipPerson(row) {
      this.$emit("tipPerson", row);
    },
    toDetail(row) {
      this.$emit("toDetail", row);
    },
    judgeShowRevoke(row) {
      return this.getTaskId(row.taskList, "REVOKE");
    },
    revoke(row) {
      this.$emit("revokeContract", row);
    },
    isShowReject() {},
    getSignList(row) {
      let temp = [];
      if (row.signatoryList.length) {
        row.signatoryList.forEach(value => {
          temp.push(value.name);
        });
        return temp.join("，");
      } else {
        return "";
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
